export const user_impersonationScope =
  "api://3370ecee-0e95-4c5e-9d86-4c734e1a13a2/user_impersonation";

export const envName = "Prod";

export const apiBaseUrl = "https://hfsv-a-api.firescotland.gov.uk/api";

export const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '872febe5-735b-4c4a-83eb-ba9baa63ad3a',
      authority: 'https://login.microsoftonline.com/791d5ea7-24c9-4270-9ed3-bfde1f8a6624/',
      redirectUri: "https://hfsvadmin.firescotland.gov.uk/",
      postLogoutRedirectUri: "https://hfsvadmin.firescotland.gov.uk/",
      cacheLocation: "localStorage"
    }
  },

  apiConfig: {
    scopes: [user_impersonationScope],
    consentScopes: ["user.read", "openid", "profile"],
    uri: 'https://hfsv-a-api.firescotland.gov.uk/api/',
    unprotectedResources: [
      'https://www.microsoft.com/en-us/*'
    ]
  },
  apiBaseUri: "https://hfsv-a-api.firescotland.gov.uk/api/",
  apiMainUri: "https://hfsv-m-api.firescotland.gov.uk/api/"
};
